define('app/sdc/upload/sdc-upload-service',["service!Upload"], function (uploadService) {
	"use strict";

	

	return {

	};
});
